'use strict';
var angular = require('angular');

var actionPayloadCtrl = ['BuilderDataService', function (BuilderDataService) {
    var _this = this;
    
    if (!this.payload) { this.payload = []; }

    this.createNewPayload = function() {
        return {
            key: null,
            value: null,
            valueConstant: false,
            fieldId:null,
            hidden: false
        };
    }

    this.newPayload = this.createNewPayload();
    
    this.addField = function (newValue) {
        // console.log('addField newValue', newValue);
        // console.log('addField this.newPayload', _this.newPayload);
        // console.log('addField this.modulo', this.modulo);

        if (!newValue.key || (!newValue.value)) {
            // console.log('Entro en return if (!newValue.key || (!newValue.value))')
            return;
        }

        _this.payload.push({
            key: newValue.key,
            value: newValue.value,
            valueConstant: newValue.valueConstant,
            fieldId: newValue.fieldId,
            id: Math.random().toString(36).substr(2, 9),
            hidden: newValue.hidden
        });
        // console.log('payload push', _this.payload)
        
        _this.newPayload = this.createNewPayload();
    };

    this.removeValue = function (index) {
        _this.payload.splice(index, 1);      
    };

    this.filterElements = function (value) {
        // console.log('value', value);
        if (value === undefined || value === null || value === '') {
            return this.valueElements;
        } else {
            let filteredValues = this.valueElements.filter(item => {
                return item.name.toLowerCase().includes(value.toLowerCase())
            })
            // console.log('filteredValues', filteredValues);
            return filteredValues;
        }
    }

    // Report Form
    this.getInputElements = function () {
        let elements = [];
        // console.log("_this.element en report payload", _this.element);
        elements = BuilderDataService.getElements(null, _this.element);

        return elements.filter(function (element) {
            if (element.id === _this.element.id) {
                return false;
            }

            switch (element.type) {
                case "text":
                case "select":
                case "formula":
                case "number":
                case "checkbox":
                case "multiple":
                case "date":
                case "timestamp":
                case "qr":
                    return true;
                default:
                    return false;
            }
        }).map(function (element) {
            return {
                id: element.id,
                name: element.name
            };
        });

    }

    this.valueElements = _this.getInputElements();
    // console.log('this.valueElements', this.valueElements);
    // console.log('reportPayload _this.element', _this.element)
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            payload: '=',
            form: '=',
            element: '='
        },
        controller: actionPayloadCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/formConfig/actionPayloadDirective.html'
    };
};
